
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { useState } from "react";

export function DonationsButton() {
  const [open, setOpen] = useState(false);

  const donationAddress = "4M7ZwhwXD7yprCn9aEC3tcNCw9Atv3xV5zYEhqNB6vuvLZSGSJg4cts2E5mLuFUVNTrSE1q6HFj2GoWz9ctHhDFe";

  const copyToClipboard = () => {
    navigator.clipboard.writeText(donationAddress);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2">
          <Heart className="h-4 w-4" />
          Donations
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Support the Dashboard</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            If you wish to donate to the dashboard to keep it going you can do a shielded dusk donation to:
          </p>
          <div className="bg-muted p-3 rounded-md">
            <code className="text-xs break-all">
              {donationAddress}
            </code>
          </div>
          <Button onClick={copyToClipboard} className="w-full" size="sm">
            Copy Address
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
